<div class="flex flex-col min-h-screen">
  <app-header></app-header>
  <router-outlet />
  <app-footer></app-footer>
</div>
